import { getOrderMenuItems } from "@icoach/accountBook/utils/orderMenuItems";
import { mapOrderMenuData } from "@icoach/accountBook/utils/mapOrderMenuData";

/**
 * 組合「純設定 → OverflowMenu menuData」，給表格 formatCell 一行用
 *
 * @param {object} rowData
 * @param {{ refresh?: Function, dialogRef?: import("react").RefObject }} ctx
 * @param {Parameters<typeof getOrderMenuItems>[1]} [options]
 */
export const buildOrderMenuData = (rowData, ctx, options = {}) => {
	const items = getOrderMenuItems(rowData, options);
	return mapOrderMenuData(items, ctx, rowData);
};
